export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#301A01',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FCCB0F',
  },
  {
    path: 'M190.72 329.216h65.024l66.048 279.552h1.024l73.728-279.552H462.08l71.68 279.552h1.024L602.88 329.216h65.024L567.04 694.784h-65.024L428.8 415.232h-1.024l-74.752 279.552h-66.048zM675.584 430.08h43.52v-22.016c0-67.584 35.328-78.848 73.216-78.848 18.432 0 31.744 1.024 40.96 3.584v45.568c-7.68-2.048-15.36-3.072-27.136-3.072-15.872 0-28.672 5.632-28.672 27.648V430.08h49.664v43.52h-49.664v221.184h-58.368V473.6h-43.52z',
    fill: '#FCCB0F',
  },
]
